export function get_sequence_name_from_id(
  seq_id: number,
  allSequenceIds: number[]
): string {
  const allSequenceIdsString = allSequenceIds
    .map((v) => v.toString())
    .join(", ");
  return seq_id === -1 ? allSequenceIdsString : seq_id.toString();
}
